import {
  CHANGE_STATUS_CUSTOMER,
  FETCH_ACTIVE_CUSTOMERS,
  FETCH_CUSTOMER,
  FETCH_CUSTOMERS,
  FETCH_INACTIVE_CUSTOMERS,
  INSERT_CUSTOMER,
} from "../config/types";

const initialState = {
  activeCustomers: [],
  inactiveCustomers: [],
  selectedCustomer: null,
};

const customersReducers = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_ACTIVE_CUSTOMERS:
      return { ...state, activeCustomers: payload };
    case FETCH_INACTIVE_CUSTOMERS:
      return { ...state, inactiveCustomers: payload };
    case FETCH_CUSTOMER:
      const selectedCustomer = findCustomer(state, payload);
      return { ...state, selectedCustomer };
    case FETCH_CUSTOMERS:
      return state;
    case INSERT_CUSTOMER:
      const activeCustomers = [...state.activeCustomers, payload];
      return { ...state, activeCustomers };
    case CHANGE_STATUS_CUSTOMER: {
      const selectedCustomer = { ...state.selectedCustomer, active: payload };
      return { ...state, selectedCustomer };
    }
    default:
      return state;
  }
};

const findCustomer = ({ activeCustomers, inactiveCustomers }, id) => {
  const customerList = [...activeCustomers, ...inactiveCustomers];
  return customerList.find((customer) => customer.id === Number(id));
};

export default customersReducers;
